import { Box, Grid } from "@mui/material";
import React from "react";
import PropertySelector from "./PropertySelector";
import FloorSelector from "./FloorSelector";
import ZoneSelector from "./ZoneSelector";
import { Options } from "../useSelectorOptions";
import { SelectedValue } from "../types";

function DeviceSelectionForm({
  hideProperty = false,
  options,
  selected,
  setSelected,
}: {
  hideProperty?: boolean;
  options: Options;
  selected: SelectedValue;
  setSelected: React.Dispatch<React.SetStateAction<SelectedValue>>;
}) {
  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          margin: "2rem 0",
        }}
      >
        <Grid
          sx={{ flex: "1", marginLeft: "1rem" }}
          container
          columnSpacing={[0, 3]}
        >
          {!hideProperty && (
            <PropertySelector
              selectedName={selected.propertyName}
              properties={options.properties}
              onSelect={(name?: string) => {
                setSelected((prev) => ({ ...prev, propertyName: name }));
              }}
            />
          )}
          <FloorSelector
            selectedFloors={selected.floors}
            onSelect={(floors) => setSelected((prev) => ({ ...prev, floors }))}
            floors={options.floors}
          />

          <ZoneSelector
            selected={selected.zoneId}
            options={options.zones}
            onSelect={(zoneId) => {
              setSelected((prev) => ({ ...prev, zoneId }));
            }}
          />
        </Grid>
      </Box>
    </Box>
  );
}

export default DeviceSelectionForm;
